app.service('operator', function (pageConfig, operatorBar) {
	var config;

	function init() {
		config = pageConfig.getData('operator');
		if (isLogged()) {
			operatorBar.init();
		}
	}
	function isLogged() {
		return config && config.isLogged === true;
	}
	return {
		init, isLogged
	};
});
